import { render, staticRenderFns } from "./ProgressionReport.vue?vue&type=template&id=e706fcb6&scoped=true&"
import script from "./ProgressionReport.vue?vue&type=script&lang=js&"
export * from "./ProgressionReport.vue?vue&type=script&lang=js&"
import style0 from "./ProgressionReport.vue?vue&type=style&index=0&id=e706fcb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e706fcb6",
  null
  
)

export default component.exports